import React from 'react';
import PropTypes from 'prop-types';

const Alert = ({ title, description, displayType }) => {
  // va-alert has no neutral status, so anything but take_action gets the mildest.
  const status = displayType === 'take_action' ? 'warning' : 'info';

  return (
    <va-alert status={status} class="vads-u-margin-top--2">
      <h4 slot="headline">{title}</h4>
      {description}
    </va-alert>
  );
};

Alert.propTypes = {
  displayType: PropTypes.string.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
};

export default Alert;
